'server only';
import { getStory } from './getStory';
import { get } from './get';

import type {
  AppConfigStoryblok,
  ArticleFolders,
  DataSourceEntry,
  Locales,
} from '@monoimin/sb-types';

type GetDatasourceEntriesResponse = {
  data: { datasource_entries: Array<DataSourceEntry> };
};

const EMPTY_RESPONSE: GetDatasourceEntriesResponse = {
  data: { datasource_entries: [] },
};

const DEFAULT_OPTIONS = {
  per_page: 220,
  dimension: 'slugs',
  datasource: 'imin-countries',
  version: 'published',
} as const;

export async function getFilteredCountries<L extends Locales = Locales>(
  page: ArticleFolders,
  locale: L
): Promise<DataSourceEntry[]> {
  try {
    const [entriesResponse, storyResponse] = await Promise.all([
      get<GetDatasourceEntriesResponse>(
        'cdn/datasource_entries',
        DEFAULT_OPTIONS
      ),
      getStory<AppConfigStoryblok>('apps/configs/immigrantinvest', {
        language: locale,
        version: 'published',
      }),
    ]);

    if (!entriesResponse || !storyResponse) return [];

    const countriesKey = `${page}Countries`;

    return (
      entriesResponse.data?.datasource_entries?.filter(
        (entry) =>
          storyResponse.data?.story?.content[countriesKey]?.includes(
            entry.value
          ) && entry.value !== 'all'
      ) ?? []
    );
  } catch {
    return EMPTY_RESPONSE.data.datasource_entries;
  }
}
